
  import Vue from 'vue'
  import FilterChipTemplate from './FilterChipTemplate.vue';
  import { autoComplete } from '@/utils/Util';

  export default Vue.extend({
    name: 'SelectionFilter',

    components: {
      FilterChipTemplate
    },
    props: ['value', 'items', 'label', 'attributes', 'mandatory', 'always', 'multi', 'small'],
    data: (_this: any): any => ({
      rules: [
          (v: any) => (!!v && Object.keys(v).length > 0) || _this.requiredError
      ],
      localSelection: _this.value[_this.attributes['value']],
      localFilters: _this.value as any,
      menu: false,
      loading: false,
    }),
    created() {
      // s
    },
    methods: {
      onSave() {
        this.localFilters[this.attributes['value']] = this.localSelection;
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onReset() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.menu = false;
      },
      onChipRemove() {
        this.$delete(this.localFilters, this.attributes['value']);
        this.$emit('input', { ...this.localFilters });
        this.$emit('delete');
      },
      autoComplete,
    },
    watch: {
      value() {
        this.localFilters = { ...this.value };
        this.localSelection = this.localFilters[this.attributes['value']];
      },
      menu() {
        if(!this.menu) {
          this.localSelection = this.localFilters[this.attributes['value']];
        }
      },
      currentTenant() {
        this.localFilters = { ...this.value }; // TODO
      }
    },
    computed: {
      filterRepr(): any {
        if(this.multi) {
          return this.items.filter((entry: any) => entry.value in this.localFilters[this.attributes['value']]).map((value: any) => value.name).join(', ');
        }
        return this.items.find((entry: any) => entry.value === this.localFilters[this.attributes['value']])?.name ?? '';
      },
      isValid(): any {
        return this.mandatory ? this.rules.reduce((acc: boolean, rule: any) => acc ? rule(this.localSelection)===true : acc, true) : true;
      },
      requiredError(): any {
        return this.$t('required');
      },
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
    }
  })
